import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Checkbox } from 'semantic-ui-react';

import * as AppActions from '../../../actions';

class WrapperAdCheckbox extends Component {
  onAdSelect = (event, data) => {
    const { id, name, value, creative, urls, checked, previewqc } = data;
    const {
      selectedAds,
      checkedCampaigns,
      indeterminateCampaigns,
      actions,
      campaignMonth
    } = this.props;
    if (checked) {
      selectedAds[value] = [
        ...selectedAds[value],
        { id, name, creative, urls, adQc: previewqc }
      ];
    } else {
      selectedAds[value] = selectedAds[value].filter((val) => val.id !== id);
    }

    if (selectedAds[value].length === 0) {
      checkedCampaigns[value] = false;
    } else if (selectedAds[value].length === campaignMonth[value].length) {
      checkedCampaigns[value] = true;
    }
    indeterminateCampaigns[value] =
      selectedAds[value].length !== campaignMonth[value].length;

    actions.updateAdPreviewData(
      selectedAds,
      checkedCampaigns,
      indeterminateCampaigns
    );
    event.stopPropagation();
  };
  isAdChecked = (id, key) => {
    const ad = this.props.selectedAds[key].filter((val) => val.id === id);
    return ad.length > 0;
  };
  render() {
    const {
      showCheckboxes,
      showCheckboxesMultiQc,
      adName,
      adId,
      campaignKey,
      creative,
      urls,
      previewQc
    } = this.props;
    if (showCheckboxes || showCheckboxesMultiQc) {
      return (
        <Checkbox
          style={{ paddingTop: '0.2em' }}
          checked={this.isAdChecked(adId, campaignKey)}
          className="select-account"
          type="checkbox"
          onChange={this.onAdSelect}
          name={adName}
          id={adId}
          value={campaignKey}
          creative={creative}
          urls={urls}
          previewqc={previewQc}
        />
      );
    }
    return null;
  }
}

const mapStateToProps = (state) => {
  const { adPreview } = state;
  const {
    selectedAds,
    checkedCampaigns,
    indeterminateCampaigns,
    showCheckboxes,
    showCheckboxesMultiQc
  } = adPreview;
  const newProps = Object.assign({}, state, {
    selectedAds,
    checkedCampaigns,
    indeterminateCampaigns,
    showCheckboxes,
    showCheckboxesMultiQc
  });
  return newProps;
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(WrapperAdCheckbox);



// WEBPACK FOOTER //
// ./src/screens/Presentation/PresentationComponents/WrapperAdCheckbox.js